// @readonly
// @enum

export const UserRolls = Object.freeze({
  ADMIN_USER: "ADMIN_USER",
  MANAGMENT_USER: "MANAGMENT_USER",
  ACCOUNTANT_USER: "ACCOUNTANT_USER",
  CRM_USER: "CRM_USER",
  CONTENT_USER: "CONTENT_USER",
  SUPPLIER: "SUPPLIER",
});

export const RollAbility = Object.freeze({
  ADMIN_USER: "All",
  MANAGMENT_USER: "UnitManagement",
  ACCOUNTANT_USER: "UnitAccounting",
  CRM_USER: "UnitCRM",
  CONTENT_USER: "UnitContent",
  SUPPLIER: "Supplier",
});

export const RollFormater = Object.freeze({
  All: "ADMIN_USER",
  UnitManagement: "MANAGMENT_USER",
  UnitAccounting: "ACCOUNTANT_USER",
  UnitCRM: "CRM_USER",
  UnitContent: "CONTENT_USER",
  Supplier: "SUPPLIER",
});
